import { useNavigation, useRoute } from '@react-navigation/native'
import { useEffect } from 'react'
import { AppRoutes } from 'navigations/app-routes'
import _ from 'lodash'

/**
 * Will navigate to the correct 'tabs' view when the page is not at /app or does not have a prent
 * And not a parent means that the page is not a child of a tab
 */

const useRouteHomeHelper = () => {
	
	const navigation = useNavigation();
	const route = useRoute();
	
	const doNavigate = () => {
		navigation.reset({
			index: 0,
			routes: [
				{
					name: AppRoutes.TABS,
					params: {
						screen: route.name
					},
				},
			]
		})
	}
	
	useEffect( () => {
		if( route.path ) {
			if( !_.startsWith( route.path, '/app' ) ) {
				doNavigate();
			}
		}
		
		const parentNavigation = navigation.getParent();
		if( typeof parentNavigation === 'undefined' ) {
			doNavigate();
		}
	}, [ navigation, route ] );
	
	return {}
}

export default useRouteHomeHelper;
